import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { ParticipationState, type Venue } from './FriendsUpcomingParticipations.types'
import FriendUpcomingParticipationAddress from './FriendUpcomingParticipationAddress'
import FriendUpcomingParticipationImage from './FriendUpcomingParticipationImage'
import FriendUpcomingParticipationName from './FriendUpcomingParticipationName'
import FriendUpcomingParticipationSport from './FriendUpcomingParticipationSport'
import FriendUpcomingParticipationState from './FriendUpcomingParticipationState'
import FriendUpcomingParticipationTimeRange from './FriendUpcomingParticipationTimeRange'

interface Props {
  imageSrc?: string
  activityName: string
  sportName: string
  start: string
  end: string
  participationState: ParticipationState | null
  venue: Venue
  onClick?: () => void
}

export function FriendUpcomingParticipationContent({
  imageSrc,
  activityName,
  sportName,
  start,
  end,
  participationState,
  venue,
  onClick,
}: Props) {
  return (
    <Stack gap={3} onClick={onClick}>
      <Stack direction="row" gap={2}>
        <FriendUpcomingParticipationImage src={imageSrc} />
        <Stack gap={2} sx={{ overflow: 'hidden' }}>
          <FriendUpcomingParticipationName name={activityName} />
          <FriendUpcomingParticipationTimeRange start={start} end={end} />
          <Stack gap={2} direction="row">
            <FriendUpcomingParticipationSport name={sportName} />
            {participationState && <FriendUpcomingParticipationState state={participationState} />}
          </Stack>
        </Stack>
      </Stack>
      <FriendUpcomingParticipationAddress
        venueName={venue.name}
        street={venue.location.street}
        zip={venue.location.zip}
        city={venue.location.city}
      />
    </Stack>
  )
}
